"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tr = void 0;

var _colors = require("./colors");

var tr = {
  colors: {
    primary: {
      backgroundColor: _colors.colors.blueAlertBorder,
      backgroundColorHoverFocus: _colors.colors.blueAlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    },
    secondary: {
      backgroundColor: _colors.colors.grayAlertBorder,
      backgroundColorHoverFocus: _colors.colors.grayAlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    },
    success: {
      backgroundColor: _colors.colors.greenAlertBorder,
      backgroundColorHoverFocus: _colors.colors.greenAlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    },
    info: {
      backgroundColor: _colors.colors.cyanAlertBorder,
      backgroundColorHoverFocus: _colors.colors.cyanAlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    },
    warning: {
      backgroundColor: _colors.colors.yellowAlertBorder,
      backgroundColorHoverFocus: _colors.colors.yellowAlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    },
    danger: {
      backgroundColor: _colors.colors.redAlertBorder,
      backgroundColorHoverFocus: _colors.colors.redAlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    },
    light: {
      backgroundColor: _colors.colors.gray100AlertBorder,
      backgroundColorHoverFocus: _colors.colors.gray100AlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    },
    dark: {
      backgroundColor: _colors.colors.gray800AlertBorder,
      backgroundColorHoverFocus: _colors.colors.gray800AlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    },
    default: {
      backgroundColor: _colors.colors.grayAlertBorder,
      backgroundColorHoverFocus: _colors.colors.grayAlertBorderTop,
      activeBackgroundColor: _colors.colors.tableBackgroundColorHoverFocus,
      activeBackgroundColorHoverFocus: _colors.colors.tableBackgroundColorHoverFocus
    }
  }
};
exports.tr = tr;